import CurrenciestList from '../../../wallet/ListView/ListView.currencies'
import { ListViewWrap } from '@src/components/wallet/ListView/ListView.styled'

interface CurrencySelectProps {
  onSelect: (currency: string) => void
  currencyList: {
    [key: string]: {
      withNetwork: boolean
    }
  }
}

export const OnRampCurrencyList = ({ onSelect, currencyList }: CurrencySelectProps) => {
  const onClickHandler = (e, currency) => {
    onSelect(currency)
  }

  const currencyNames = Object.keys(currencyList)

  return (
    <ListViewWrap>
      <CurrenciestList noBalance currencies={currencyNames} setActive={onClickHandler} />
    </ListViewWrap>
  )
}
